import { useEffect, useState } from "react";
import { RESULT_VIDEOS } from "../../data/results";

const useColumns = () => {
  const get = () => (window.innerWidth >= 1024 ? 3 : 2);
  const [cols, setCols] = useState(get);
  useEffect(() => {
    const onResize = () => setCols(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return cols;
};

const CAPTION_WEIGHT = 0.22;

const distribute = (items, n) => {
  const cols = Array.from({ length: n }, () => ({ h: 0, items: [] }));
  items.forEach((it) => {
    const target = cols.reduce((a, b) => (b.h < a.h ? b : a));
    target.items.push(it);
    target.h += it.h / it.w + CAPTION_WEIGHT;
  });
  return cols.map((c) => c.items);
};

const Frame = ({ children, caption, testid }) => (
  <figure className="lux-card overflow-hidden p-1.5 sm:p-2" data-testid={testid}>
    {children}
    <figcaption className="px-1.5 pb-1.5 pt-2.5 text-[12px] leading-snug text-[#d8d0bf] sm:px-2 sm:text-[13px]">{caption}</figcaption>
  </figure>
);

const VideoTile = ({ v }) => (
  <Frame caption={v.caption} testid={`receipts-${v.id}`}>
    <video src={v.src} poster={v.poster} autoPlay muted loop playsInline preload="metadata" className="block w-full rounded-[10px] bg-black" style={{ aspectRatio: `${v.w}/${v.h}` }} aria-label={v.caption} />
  </Frame>
);

const ShotTile = ({ s, onOpen }) => (
  <Frame caption={s.caption} testid={`receipts-${s.id}`}>
    <button type="button" onClick={() => onOpen(s)} className="group block w-full overflow-hidden rounded-[10px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--gold)]" aria-label={`Open: ${s.caption}`} data-testid={`receipts-${s.id}-open-button`}>
      <img src={s.src} alt={s.caption} loading="lazy" width={s.w} height={s.h} className="block h-auto w-full transition-transform duration-500 group-hover:scale-[1.03]" style={{ aspectRatio: `${s.w}/${s.h}` }} />
    </button>
  </Frame>
);

export const ResultsMasonry = ({ shots, onOpen }) => {
  const n = useColumns();
  const items = [...RESULT_VIDEOS.map((v) => ({ ...v, kind: "video" })), ...shots.map((s) => ({ ...s, kind: "shot" }))];
  const columns = distribute(items, n);
  return (
    <div className="mt-12 flex items-start gap-3 sm:gap-5" data-testid="receipts-masonry">
      {columns.map((col, i) => (
        <div key={i} className="flex min-w-0 flex-1 flex-col gap-3 sm:gap-5">
          {col.map((it) => (it.kind === "video" ? <VideoTile key={it.id} v={it} /> : <ShotTile key={it.id} s={it} onOpen={onOpen} />))}
        </div>
      ))}
    </div>
  );
};
